<template>
  <div>
    <DxDataGrid
      ref="dataGridRef"
      :data-source="dsModule"
      key-expr="ID"
      :allowColumnReordering="true"
      :allowColumnResizing="true"
      :show-borders="true"
      :show-row-lines="true"
      :show-column-lines="false"
      :column-auto-width="true"
      @row-inserting="onRowInserting"
      @row-updating="onRowUpdating"
      @row-removing="onRowRemoving"
    >
      <DxEditing mode="row" :allow-updating="true" :allow-deleting="true" :allow-adding="true" />
      <DxFilterRow :visible="true" />
      <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
      <DxPaging :page-size="20" />
      <DxSorting mode="multiple" />
      <DxToolbar>
        <DxGridItem name="addRowButton" />
        <DxGridItem name="searchPanel" />
      </DxToolbar>
      <DxSearchPanel :visible="true" placeholder="Cauta..." />
      <DxColumn data-field="Cod" />
      <DxColumn data-field="Nume" />
      <DxColumn data-field="Explicatie" />
      <DxColumn data-field="Ordine" data-type="number" :width="90" />
    </DxDataGrid>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  DxColumn,
  DxDataGrid,
  DxEditing,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSorting,
  DxToolbar,
  DxItem as DxGridItem,
  DxSearchPanel,
} from 'devextreme-vue/data-grid';
import notify from 'devextreme/ui/notify';
import AUTH_DrepturiModule from '@/services/AUTH/AUTH_DrepturiModule';

export default defineComponent({
  components: {
    DxDataGrid, DxColumn, DxEditing, DxFilterRow, DxLoadPanel,
    DxPaging, DxSorting, DxToolbar, DxGridItem, DxSearchPanel,
  },
  emits: ['modules-changed'],
  data() {
    return {
      dsModule: [] as any[],
    };
  },
  methods: {
    loadModules() {
      AUTH_DrepturiModule.getModule()
        .then((r: any) => {
          this.dsModule = r.data ?? [];
          this.$emit('modules-changed', this.dsModule);
        })
        .catch(console.error);
    },
    onRowInserting(e: any) {
      e.cancel = new Promise<void>((resolve, reject) => {
        AUTH_DrepturiModule.save(e.data)
          .then(() => {
            notify('Modulul a fost adăugat!', 'success', 1500);
            this.loadModules();
            resolve();
          })
          .catch((err: any) => {
            console.error(err);
            notify('Eroare la adăugare!', 'error', 2000);
            reject();
          });
      });
    },
    onRowUpdating(e: any) {
      const data = { ...e.oldData, ...e.newData };
      e.cancel = new Promise<void>((resolve, reject) => {
        AUTH_DrepturiModule.update(e.key, data)
          .then(() => {
            notify('Modulul a fost actualizat!', 'success', 1500);
            this.loadModules();
            resolve();
          })
          .catch((err: any) => {
            console.error(err);
            notify('Eroare la actualizare!', 'error', 2000);
            reject();
          });
      });
    },
    onRowRemoving(e: any) {
      e.cancel = new Promise<void>((resolve, reject) => {
        AUTH_DrepturiModule.delete(e.key)
          .then(() => {
            notify('Modulul a fost șters!', 'success', 1500);
            this.loadModules();
            resolve();
          })
          .catch((err: any) => {
            console.error(err);
            notify('Eroare la ștergere!', 'error', 2000);
            reject();
          });
      });
    },
  },
  mounted() {
    this.loadModules();
  },
});
</script>
